import React from "react";
import Icons from "../../common/components/Icons";
import Paragraph from "../../common/ui/Paragraph";

const Card = ({ obj }) => {
  return (
    <div className="p-3.5 sm:p-4 md:p-[22px] rounded-lg flex max-sm:flex-col max-sm:gap-y-3 sm:items-center gap-x-3 bg-white">
      <Icons icon={obj.icon} className="min-w-14" />
      <div>
        <h3 className="font-bold !leading-133 md:!leading-100 text-lg text-custom-dark-blue max-sm:max-w-[260px] ">
          {obj.title}
        </h3>
        <Paragraph className="!text-custom-dark-blue pt-2 !text-sm">
          {obj.description}
        </Paragraph>
      </div>
    </div>
  );
};

export default Card;
